import ImagePlacehodler from "@components/ArticleCard/components/ImagePlacehodler";
import { faCircle, faPlay } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import ArticleThumbnail from "@pages/Article/components/ArticleThumbnail/ArticleThumbnail.tsx";
import { FeedMedia } from "@pages/Article/utils/types";
import { cn } from "@src/app/util/helpers";
import { CaaSImageFilters } from "@typings/OptimisedImage";
import { IS_PLAYWRIGHT } from "@util/constant";

type CardImageProps = {
  /** Media object containing image or video data */
  media: FeedMedia;
  /** Optional additional styling for the article image container*/
  className?: string;
  /** Optional additional styling for the images */
  imageClassName?: string;
  /** Filters to apply to the image */
  filters?: CaaSImageFilters;
  /** Link to redirected after clicking the image */
  link?: string;
  /** Orientation of the image */
  orientation?: "landscape" | "square" | "original" | "portrait";
  /** Whether to preload the LCP image */
  preloadLCPImage?: boolean;
  /** Flag to indicate if it a video */
  isVideo?: boolean;
  /** Aspect ratio for the image */
  aspectRatio?: string;
  /** Position of the play icon for video */
  playIconPosition?: "lower-left" | "";
  /** Optional additional stylings for card image wrapper*/
  imageWrapperClassName?: string;
};

/**
 * CardImage component that renders an image or video thumbnail with optional filters and styles.
 * It also displays a play icon for videos.
 */
const CardImage = ({
  media,
  className,
  imageClassName = "",
  filters,
  link = "",
  orientation = "original",
  preloadLCPImage = false,
  isVideo = false,
  aspectRatio = "aspect-3x2",
  playIconPosition,
  imageWrapperClassName,
}: CardImageProps): React.ReactElement => {
  return (
    <>
      {!IS_PLAYWRIGHT ? (
        <div className={cn("relative", imageWrapperClassName)}>
          <ArticleThumbnail
            media={media}
            className={className}
            imageClassName={imageClassName}
            filters={filters}
            articleLink={link}
            orientation={orientation}
            preloadLCPImage={preloadLCPImage}
          />

          {isVideo ? (
            <div
              className={
                playIconPosition === "lower-left"
                  ? "fa-stack absolute bottom-3 left-2"
                  : ""
              }
            >
              <FontAwesomeIcon
                icon={faCircle}
                inverse
                className="fa-stack-2x z-10 opacity-80"
              />

              <FontAwesomeIcon icon={faPlay} className="fa-stack-1x z-10" />
            </div>
          ) : null}
        </div>
      ) : (
        <ImagePlacehodler
          aspectRatio={aspectRatio}
          className={imageWrapperClassName}
        />
      )}
    </>
  );
};

export default CardImage;
